export default __webpack_public_path__ + "static/media/yape.053ea36c.jpeg";